import script from "./CHElegant.vue?vue&type=script&setup=true&lang=js"
export * from "./CHElegant.vue?vue&type=script&setup=true&lang=js"

import "./CHElegant.vue?vue&type=style&index=0&id=1a18c3d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a18c3d7"]])

export default __exports__